import request from '@/utils/request'

/**
 * 设置-角色管理-角色列表
 * @param {string} token
 */
export function roleList(params) {
  return request({
    url: '/api/v1/role/roleList',
    method: 'get',
    params,
  })
}

/**
 * 设置-角色管理-菜单与功能结构树
 * @param {string} token
 */
export function getTree(params) {
  return request({
    url: '/api/v1/role/tree',
    method: 'get',
    params,
  })
}

/**
 * 设置-角色管理-新增角色
 * @param {string} token
 * @param {boolean} hasDept 是否具有科室发布文章能力，true有，false无
 * @param {boolean} hasHospital 是否具有医院发布文章能力，true有，false无
 * @param {array} nodeData 选中的节点数据
 * @param {string} roleName 角色名称
 * @param {boolean} state 角色状态，true启用，false禁用
 */
export function addRole(data) {
  return request({
    url: '/api/v1/role/addRole',
    method: 'post',
    data,
  })
}

/**
 * 设置-角色管理-角色详情
 * @param {string} token
 * @param {string} roleId 角色id
 */
export function getRole(params) {
  return request({
    url: '/api/v1/role/getRole',
    method: 'get',
    params,
  })
}

/**
 * 设置-角色管理-编辑角色
 * @param {string} token
 * @param {boolean} hasDept 是否具有科室发布文章能力，true有，false无
 * @param {boolean} hasHospital 是否具有医院发布文章能力，true有，false无
 * @param {array} nodeData 选中的节点数据
 * @param {string} roleName 角色名称
 * @param {string} roleId 角色id
 * @param {boolean} state 角色状态，true启用，false禁用
 */
export function editRole(data) {
  return request({
    url: '/api/v1/role/editRole',
    method: 'post',
    data,
  })
}

/**
 * 设置-角色管理-角色状态改变
 * @param {string} token
 * @param {string} roleId 角色id
 */
export function stateRole(params) {
  return request({
    url: '/api/v1/role/stateRole',
    method: 'get',
    params,
  })
}

/**
 * 设置-角色管理-删除角色
 * @param {string} token
 * @param {string} roleId 角色id
 */
export function delRole(params) {
  return request({
    url: '/api/v1/role/delRole',
    method: 'get',
    params,
  })
}
